import { css, styled } from "styled-components";
import { FaTrash } from "react-icons/fa";
import { CardItem } from "types/types";
import { createStyledIcon } from "utils/iconUtils";

const TrashIcon = createStyledIcon(FaTrash);

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(50% - ${({ theme }) => theme.spacing.lg});
  max-width: calc(50% - ${({ theme }) => theme.spacing.lg});
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: ${({ theme }) => theme.spacing.md};
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1024px) {
    flex: 1 1 calc(50% - ${({ theme }) => theme.spacing.lg});
    max-width: calc(50% - ${({ theme }) => theme.spacing.lg});
  }

  @media (max-width: 600px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

export const CardHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  padding-bottom: ${({ theme }) => theme.spacing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.colors.subtle_5};
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.secondary};
  flex: 1;
  margin-right: ${({ theme }) => theme.spacing.sm};
  font-weight: 600;
  transition: text-decoration 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
`;

export const DeleteIcon = styled(TrashIcon)`
  cursor: pointer;
  color: #e03e3e;
  transition: color 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const InfoRowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const Circle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.secondary};
  margin-right: ${({ theme }) => theme.spacing.xs};
`;

export const InfoText = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 0.9rem;
`;

export const CardBadge = styled.span<{ $badgeType: CardItem["type"] }>`
  display: inline-block;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: bold;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  ${({ $badgeType, theme }) => {
    switch ($badgeType) {
      case "article":
        return css`
          background: ${theme.colors.success || "#79c978"};
        `;
      case "pin":
        return css`
          background: ${theme.colors.info || "#E60023"};
        `;
      case "post":
      default:
        return css`
          background: ${theme.colors.primary || "#0866ff"};
        `;
    }
  }}

  color: ${({ theme }) => theme.colors.white};

  &:hover {
    /* transform: scale(1.05); */
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
  }
`;
